import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 * @param {string} queryString - query params for listModel (limit, pageNumber, filters)
 */
export function requestMarketingLeadList(queryString) {
  const q = queryString ? `?${queryString}` : "";
  return fetch.get(`${BASE_URL}/api/app/marketing-lead${q}`);
}

/**
 * @param {string} queryString - matches getKpis (startDate, endDate, location, sourceType, etc.)
 */
export function requestMarketingKpi(queryString) {
  const q = queryString ? `?${queryString}` : "";
  return fetch.get(`${BASE_URL}/api/app/marketing-lead/getKpi${q}`);
}

/**
 * Promote marketing lead to Sales Pipeline `lead`.
 * @param {string} mktLeadId
 * @param {{ leadOwner?: string, leadStage?: string }} body
 */
export function requestPromoteMarketingLead(mktLeadId, body) {
  return fetch.post(
    `${BASE_URL}/api/app/marketing-lead/promote-to-pipeline/${mktLeadId}`,
    body || {}
  );
}

/**
 * Update marketing pool lead (`mktlead`).
 * @param {string} mktLeadId
 * @param {object} body - fields accepted by `updateModel('mktlead')`
 */
export function requestUpdateMarketingLead(mktLeadId, body) {
  return fetch.put(`${BASE_URL}/api/app/marketing-lead/${mktLeadId}`, body);
}

/**
 * Single marketing lead with full populate (`getByIdModel`).
 * @param {string} mktLeadId
 */
export function requestMarketingLeadById(mktLeadId) {
  return fetch.get(`${BASE_URL}/api/app/marketing-lead/getById/${mktLeadId}`);
}

/**
 * @param {string} mktLeadId
 * @param {{ title: string, description: string }} body
 */
export function requestMarketingLeadAddNote(mktLeadId, body) {
  return fetch.patch(`${BASE_URL}/api/app/marketing-lead/add-note/${mktLeadId}`, body);
}

/**
 * @param {string} mktLeadId
 * @param {string} noteId
 */
export function requestMarketingLeadDeleteNote(mktLeadId, noteId) {
  return fetch.delete(
    `${BASE_URL}/api/app/marketing-lead/delete-note/${mktLeadId}/${noteId}`
  );
}
